import dynamic from 'next/dynamic'
import React from 'react'
import styled from 'styled-components'
import { media } from 'utils/media'
import { ArrowLink as OriginalArrowLink } from 'lib/ArrowLink'
import { MaxWidthContainer } from 'lib/Section'
import { SectionHeader } from 'modules/homepage/SectionHeader'
import { useReviews } from 'modules/reviews/list/queries/useReviews'

const CompactedReview = dynamic(() => import('modules/reviews/common/components/CompactedReview').then((res) => res.CompactedReview))

const Section = styled(MaxWidthContainer)`
  padding: 0 var(--wide-grid-spacing);
`

const TitleWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  column-gap: 16px;
  justify-content: space-between;
  margin-bottom: 24px;
`

const ArrowLink = styled(OriginalArrowLink)`
  display: flex;
`

const ListGroup = styled.ul`
  display: flex;
  flex-direction: column;
  gap: var(--wide-grid-spacing);
`

const List = styled.div`
  display: grid;
  gap: var(--wide-grid-spacing);
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));

  @media ((max-width: 1116px) and (min-width: 727px)) {
    ${ListGroup}:last-child {
      display: none;
    }
  }

  ${media.phoneDown} {
    grid-template-columns: 1fr;
  }
`

export const LastReviewsSection = () => {
  const { data: mediaReviewsData } = useReviews({ variables: { take: 3, withMedia: true, minimumScore: 80 } })
  const { data, loading } = useReviews({ variables: { take: 3, withMedia: false, minimumScore: 60 } })

  if (!data || loading) {
    return null
  }

  return (
    <Section as="section">
      <TitleWrapper>
        <SectionHeader title="Latest reviews" />

        <ArrowLink arrowPosition="right" label="View all" url="/reviews" textProps={{ size: 'ps', weight: 'medium' }} />
      </TitleWrapper>

      <List>
        <ListGroup>
          {data?.reviews[0] && (
            <li>
              <CompactedReview review={data?.reviews[0]} />
            </li>
          )}
          {mediaReviewsData?.reviews[0] && (
            <li>
              <CompactedReview review={mediaReviewsData?.reviews[0]} />
            </li>
          )}
        </ListGroup>

        <ListGroup>
          {mediaReviewsData?.reviews[1] && (
            <li>
              <CompactedReview review={mediaReviewsData?.reviews[1]} />
            </li>
          )}

          {data?.reviews[1] && (
            <li>
              <CompactedReview review={data?.reviews[1]} />
            </li>
          )}
        </ListGroup>

        <ListGroup>
          {data?.reviews[2] && (
            <li>
              <CompactedReview review={data?.reviews[2]} />
            </li>
          )}
          {mediaReviewsData?.reviews[2] && (
            <li>
              <CompactedReview review={mediaReviewsData?.reviews[2]} />
            </li>
          )}
        </ListGroup>
      </List>
    </Section>
  )
}
